/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { ModelUtils } from '../util/ModelUtils';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { Node } from '../../core/models/Node';
import { NodePath } from '../../core/models/NodePath';
import { OasHeader } from '../../openapi/models/OasHeader';
import { IOasHeaderParent } from '../../openapi/models/IOasHeaderParent';

/**
 * A command used to create a new http header.
 * @author vvilerio
 * @extends AbstractCommand
 * @class
 */
export class NewHeaderCommand extends AbstractCommand {
    public _nodePath : NodePath;

    public _name : string;

    public _newHeader : any;

    public _created : boolean;

    public constructor(parent? : any, name? : any) {
        if(((parent != null && (parent["__interfaces"] != null && parent["__interfaces"].indexOf("io.apicurio.datamodels.openapi.models.IOasHeaderParent") >= 0 || parent.constructor != null && parent.constructor["__interfaces"] != null && parent.constructor["__interfaces"].indexOf("io.apicurio.datamodels.openapi.models.IOasHeaderParent") >= 0)) || parent === null) && ((typeof name === 'string') || name === null)) {
            let __args = arguments;
            super();
            if(this._nodePath===undefined) this._nodePath = null;
            if(this._name===undefined) this._name = null;
            if(this._newHeader===undefined) this._newHeader = null;
            if(this._created===undefined) this._created = false;
            if(this._nodePath===undefined) this._nodePath = null;
            if(this._name===undefined) this._name = null;
            if(this._newHeader===undefined) this._newHeader = null;
            if(this._created===undefined) this._created = false;
            (() => {
                this._nodePath = Library.createNodePath(<Node><any>parent);
                this._name = name;
            })();
        } else if(parent === undefined && name === undefined) {
            let __args = arguments;
            super();
            if(this._nodePath===undefined) this._nodePath = null;
            if(this._name===undefined) this._name = null;
            if(this._newHeader===undefined) this._newHeader = null;
            if(this._created===undefined) this._created = false;
            if(this._nodePath===undefined) this._nodePath = null;
            if(this._name===undefined) this._name = null;
            if(this._newHeader===undefined) this._newHeader = null;
            if(this._created===undefined) this._created = false;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[NewHttpHeaderCommand] Executing.");
        this._created = false;
        let node : IOasHeaderParent = <IOasHeaderParent><any>this._nodePath.resolve(document);
        if(this.isNullOrUndefined(node)) {
            return;
        }
        let header : OasHeader = node.getHeader(this._name);
        if(ModelUtils.isDefined(header)) {
            return;
        }
        let nodeHeader : OasHeader = node.createHeader(this._name);
        node.addHeader(this._name, nodeHeader);
        this._created = true;
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[NewHeaderCommand] Reverting.");
        if(!this._created) {
            LoggerCompat.info("[NewHeaderCommand]  header already existed, nothing done so no rollback necessary.");
            return;
        }
        let node : IOasHeaderParent = <IOasHeaderParent><any>this._nodePath.resolve(document);
        if(this.isNullOrUndefined(node)) {
            return;
        }
        node.removeHeader(this._name);
    }
}
NewHeaderCommand["__class"] = "io.apicurio.datamodels.cmd.commands.NewHeaderCommand";
NewHeaderCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




